export default "__VITE_ASSET__CX$F1s_p__"